'use client';

import dynamic from 'next/dynamic';

const HelpWidget = dynamic(() => import('./src/HelpWidget').then((mod) => mod.HelpWidget), { ssr: false });

export { HelpWidget as HelpWidgetLazy };
